<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted(){
  }
}
</script>
<style lang="less">
  *{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
html,body{
    min-width: 1400px;
    color:@666;
    height:100%;
    text-align: left;
    font-size: 14px;
    font-family: 'Microsoft Yahei','Avenir',
    Helvetica,
    Arial,
    sans-serif;
}
a,button{
    cursor: pointer;
}
#app{
    height:100%;
    >div{
      height:100%;
    }
.el-progress-bar__outer{
  background:#fff;
}
ul li,ol li{
    list-style: none;
}
.lf{
    float: left;
}
.rt{
    float: right;
}
.clear{
  clear:both;
  display: block;
}
.clear:after{
  content:'';
  clear:both;
  display: block;
}

button{
    outline: none;
    border:none;
    border-radius: 3px;
}
 .lcNext.el-button{
      display:block;
      margin:10px auto 0;
      width:180px;
      height:42px;
      line-height:42px;
  }

  .btnBox{
    text-align: center;
    margin:10px 0 5px 0;
  }
  .el-dialog{
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  /*height:600px;*/
  max-height:calc(100% - 30px);
  max-width:calc(100% - 30px);
}
.el-dialog .el-dialog__body{
  //flex:1;
  overflow: auto;
}
p.cont-title{
  position: relative;
  color:#333;
  font-weight: bold;
  font-size: 16px;
  padding-left:8px;
  height:36px;
  line-height:36px;
  margin-bottom:15px;
}
p.cont-title:after{
  content:'';
  display: block;
  width: 0;
  border-left:3px solid @base-color;
  position: absolute;
  left:0;
  top:10px;
  height:16px;
}

.el-input-group__append, .el-input-group__prepend{
  background:@base-color;
  border-color:@base-color;
}
.el-icon-search{
  color:#fff;
  font-size: 18px;
}
.pageNum {
  line-height: 52px;
}
.red{
  color:@base-color;
}
.warning{
  color:@warning-color;
}
.success{
  color:@success-color
}
table.show{
    border: 1px solid #ddd;
    width: 800px;
    margin: 0 auto;
    border-collapse: collapse;
    //margin-top:50px;
    td{
      border: 1px solid #ddd;
      line-height:50px;
      padding:0 5px;
      font-size: 16px;
      color:#333;
    }
    td:first-child{
      background: @base-Bg;
      text-align: right;
    }
}
.edui-default .edui-for-attachment .edui-icon{
    background-position: -759px -78px;
    width:72px !important;
  }
}
.box{
  height:calc(~"100% - 60px");
}
.box.noBtn{
  height:100%;
}
  .el-button.el-button--text{
    min-width: auto;
    margin:0 3px;
    height:auto;
    text-decoration: underline;
    color:@warning-color;
  }
  .el-button.el-button--text:hover, .el-button.el-button--text:focus{
    color:fade(@warning-color,80%);
  }

  .el-button.el-button--text.redColor{
    color:@base-color;
  }
   .el-button.el-button--text.redColor:hover, .el-button.el-button--text.redColor:focus{
    color:fade(@base-color,80%);
  }
  .loading p{
    padding-top: 150px;
    padding-bottom:30px;
    text-align: center;
    font-size: 28px;
  }
  #colorfulPulse {
    width: 100%;
    text-align: center;
    height: 50px;
    margin:0 auto;
  }
  #colorfulPulse span {
    display: inline-block;
    width: 10px;
    height: 40px;
    animation-name: scale;
    -webkit-animation-name: scale;
    -moz-animation-name: scale;
    -ms-animation-name: scale;
    -o-animation-name: scale;
    animation-duration: 1.2s;
    -webkit-animation-duration: 1.2s;
    -moz-animation-duration: 1.2s;
    -ms-animation-duration: 1.2s;
    -o-animation-duration: 1.2s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    -ms-animation-iteration-count: infinite;
    -o-animation-iteration-count: infinite;
    /* animation: name duration timing-function delay iteration-count direction */
    /* 属性：动画名称 完成动画花费的时间 动画速度曲线  延迟时间 播放次数 反向播放动画*/
    /*
    timing-function：linear:匀速，ease:慢快慢，ease-in：慢开始，ease-out：慢结束，ease-in-out:慢开始和结束
   iteration-count：数字/infinite（无数次）

    */
  }
  span.item-1 {
    background: #d70a30;
  }
  span.item-2 {
    background: #d70a30;
  }
  span.item-3 {
    background: #d70a30;
  }
  span.item-4 {
    background: #d70a30;
  }
  span.item-5 {
    background: #d70a30;
  }
  span.item-6 {
    background: #d70a30;
  }
  span.item-7 {
    background: #d70a30;
  }

  .item-1 {
    animation-delay: -1s;
    -webkit-animation-delay: -1s;
    -moz-animation-delay: -1s;
    -ms-animation-delay: -1s;
    -o-animation-delay: -1s;
  }

  .item-2 {
    animation-delay: -0.9s;
    -webkit-animation-delay: -0.9s;
    -moz-animation-delay: -0.9s;
    -ms-animation-delay: -0.9s;
    -o-animation-delay: -0.9s;
  }

  .item-3 {
    animation-delay: -0.8s;
    -webkit-animation-delay: -0.8s;
    -moz-animation-delay: -0.8s;
    -ms-animation-delay: -0.8s;
    -o-animation-delay: -0.8s;
  }

  .item-4 {
    animation-delay: -0.7s;
    -webkit-animation-delay: -0.7s;
    -moz-animation-delay: -0.7s;
    -ms-animation-delay: -0.7s;
    -o-animation-delay: -0.7s;
  }

  .item-5 {
    animation-delay: -0.6s;
    -webkit-animation-delay: -0.6s;
    -moz-animation-delay: -0.6s;
    -ms-animation-delay: -0.6s;
    -o-animation-delay: -0.6s;
  }

  .item-6 {
    animation-delay: -0.5s;
    -webkit-animation-delay: -0.5s;
    -moz-animation-delay: -0.5s;
    -ms-animation-delay: -0.5s;
    -o-animation-delay: -0.5s;
  }

  .item-7 {
    animation-delay: -0.4s;
    -webkit-animation-delay: -0.4s;
    -moz-animation-delay: -0.4s;
    -ms-animation-delay: -0.4s;
    -o-animation-delay: -0.4s;
  }

  @-webkit-keyframes scale {
    0%, 40%, 100% {
      -moz-transform: scaleY(0.2);
      -ms-transform: scaleY(0.2);
      -o-transform: scaleY(0.2);
      -webkit-transform: scaleY(0.2);
      transform: scaleY(0.2);
    }

    20%, 60% {
      -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
  @-moz-keyframes scale {
    0%, 40%, 100% {
      -moz-transform: scaleY(0.2);
      -ms-transform: scaleY(0.2);
      -o-transform: scaleY(0.2);
      -webkit-transform: scaleY(0.2);
      transform: scaleY(0.2);
    }

    20%, 60% {
      -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
  @-ms-keyframes scale {
    0%, 40%, 100% {
      -moz-transform: scaleY(0.2);
      -ms-transform: scaleY(0.2);
      -o-transform: scaleY(0.2);
      -webkit-transform: scaleY(0.2);
      transform: scaleY(0.2);
    }

    20%, 60% {
      -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
  @keyframes scale {
    0%, 40%, 100% {
      -moz-transform: scaleY(0.2);
      -ms-transform: scaleY(0.2);
      -o-transform: scaleY(0.2);
      -webkit-transform: scaleY(0.2);
      transform: scaleY(0.2);
    }

    20%, 60% {
      -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
</style>
